import React from 'react';
import { Typography } from '@material-ui/core';

export default function hyperlocalPreview(){
    return (
        <Typography> Preview Details here </Typography>
    )
}